<template>


	<div class="container">
		<h4>{{$t('roles.permissions')}}</h4>
		<h4 style="text-align: center">{{ roleName.toUpperCase() }}</h4>

		<fieldset class="row" style="border: 1px solid #a4a8ab;padding-left: 30px;padding-right: 30px;border-radius: 5px;padding-top: 10px;
		background-color:#f5f5f5; padding-bottom: 10px ">
			<div v-for="(value, key, index) in groupPermList" class="row"
				 style="padding: 3px;border:solid 1px #a4a8ab;margin-top:15px">
				<div class="form-check col-sm-12" style="margin-top: -15px;">
					<mark style="background-color: #f5f5f5"><i style="color: green;" class="fa fa-check"></i></mark>

					<span class="form-check-label" style="color: green; ">
						<mark style="background-color: #f5f5f5">{{key }}</mark>
					</span>


				</div>
				<div v-for="child in value" class="col-sm-3" style="margin-left: 50px;padding-top: 5px" :key="child.id">
					<input :id="'child' + child.id" class="form-check-input" type="checkbox" :value="child.id"
						   v-model="payloadArray.selectedArray" @change="onChangeCheckbox(child.id)">

					<label :for="'child' + child.id" style="color: #000;">{{child.name}}</label>
				</div>
			</div>
		</fieldset>

		<div>


			<b-alert variant="success" v-model="showDismissibleAlert">
				Dismissible Alert!
			</b-alert>

			<b-alert
				:show="dismissCountDown"
				dismissible
				variant="success"
				@dismissed="dismissCountDown=0"
			>
				<p>Malumot qoshilyapti {{ dismissCountDown }} seconds...</p>
				<b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="4px"/>
			</b-alert>

			<b-button style="float: right" @click="savePermission" variant="success" class="m-1">
				{{$t('actions.save')}}
			</b-button>

		</div>
	</div>


</template>

<!---->
<script>
	import permissionsData from './PermissionsData'
	import List from './List'
	import {mapActions, mapGetters} from "vuex";

	export default {
		name: 'Permissions',

		props: {
			caption: {
				type: String,
				default: 'Permissions'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data: () => {
			return {
				currentPage: 1,
				perPage: 20,
				dismissSecs: 1,
				dismissCountDown: 0,
				showDismissibleAlert: false,
				items: permissionsData.filter((user) => user.id < 42),

				permField: [
					{key: 'id'},
					{key: 'name'},
					{key: 'actions'},
				],
				item: {
					name: '',
					code: '',

				},
				payloadArray: {
					id: null,
					selectedArray: []
				},
				roleName: 'Test',


			}


		},
		computed: {
			...mapGetters('permissions', [
				'permissions', 'groupPermList'
			]),
			...mapGetters('roles', [
				'response', 'rolesList', 'permList'
			]),
		},


		methods: {
			getBadge(status) {
				return status === 'Active' ? 'success'
					: status === 'Inactive' ? 'secondary'
						: status === 'Pending' ? 'warning'
							: status === 'Banned' ? 'danger' : 'primary'
			},
			...mapActions('roles', [
					'FetchPermList', 'saveRolePermissions', 'getRolesList'
				],
			),
			...mapActions('permissions', [
				'fetchPerm', 'fetchGroupPermissions'
			]),
			getRowCount(items) {
				return items.length
			},
			userLink(id) {
				return `users/${id.toString()}`
			},
			rowClicked(item) {
				const userLink = this.userLink(item.id);
				this.$router.push({path: userLink})
			},
			async savePermission() {
				this.payloadArray.id = await this.$route.params.id;
				this.saveRolePermissions(this.payloadArray);
				this.dismissCountDown = this.dismissSecs;

			},


			onChangeCheckbox(id) {
				/* CHECKBOX CHANGE BO'LGANDA ISHLAYDI */
				this.payloadArray.id = id;

			},
			getRole() {
				let roleId = this.$route.params.id;
				let roleWithId = this.rolesList.find(role => {
					if (role.id == roleId) {
						return role;
					} else {
						return null;
					}
				});
				this.roleName = roleWithId ? roleWithId.name : 'testFromGetRole';
			}
		},
		async mounted() {
			await this.fetchGroupPermissions();
			if (this.rolesList.length < 1) {
				await this.getRolesList();
			}
			this.getRole();
		},
		async created() {
			let roleId = this.$route.params.id;
			await this.FetchPermList(roleId);

			for (let perm of this.permList) {
				/* BU FOR LOOP ROLENING PERMISSION.ID LARINI SELECTEDARRAYGA SAQLAB OLADI KEYIN PAGE DA CHECKED QILIB KO'RSATISH UCHUN */
				this.payloadArray.selectedArray.push(perm.id);
			}
		}
	}
</script>

<style scoped>

</style>
